import { useSearchParams } from "react-router-dom";
import { ControlPanel, DiscountsTab, HistoryTab, ProxyTab } from "./components";
import style from "./CustomerPage.module.scss";

export function CustomerPage() {
    const [queryParams, setQueryParams] = useSearchParams();

    return (
        <main
            style={queryParams.get("tab") === "discounts" ? {
                height: "fit-content"
            } : {}}
            className={style.page}
        >
            <ControlPanel />
            <div className={style.container}>
                <div className={style.tabs}>
                    <button
                        className={queryParams.get("tab") === "proxy" ? style.active : ""}
                        onClick={() => {
                            setQueryParams((params => {
                                params.set("tab", "proxy")

                                return params
                            }))
                        }}
                    >
                        Модеми
                    </button>
                    <button
                        className={queryParams.get("tab") === "history" ? style.active : ""}
                        onClick={() => {
                            setQueryParams((params => {
                                params.set("tab", "history")

                                return params
                            }))
                        }}
                    >
                        Історія покупок
                    </button>
                    <button
                        className={queryParams.get("tab") === "discounts" ? style.active : ""}
                        onClick={() => {
                            setQueryParams((params => {
                                params.set("tab", "discounts")

                                return params
                            }))
                        }}
                    >
                        Знижки
                    </button>
                </div>
                {
                    queryParams.get("tab") === "proxy"
                        ? <ProxyTab />
                        : null
                }
                {
                    queryParams.get("tab") === "history"
                        ? <HistoryTab />
                        : null
                }
                {
                    queryParams.get("tab") === "discounts"
                        ? <DiscountsTab />
                        : null
                }
            </div>
        </main>
    );
}
